export const TopBarCy = {
    Customers: 'menu-customers-list',
    InvoiceCreator: 'menu-invoice-creator',
    Logo: 'conta-logo',
    OrgSelector: 'topbar-org-selector',
    Suppliers: 'menu-suppliers-list',
    TransactionManager: 'menu-entry-register-transaction',
    Reports: 'top-bar-menu-item-reports'
}